<template>
  <div class="careersApply">
    <top-header></top-header>
	<div class="job">
		  <b-container >
		
		
			<b-row class="job-header">
				<b-col lg="7" md="12" sm="12">
				<h1>{{careersList.job_title}}</h1>
					<ul class="list-inline job-attributes">
						<li title="Location">
							<i class="fa fa-map-marker"></i>{{careersList.location}}                  
						</li>
						<li id="resumator-job-employment" title="Type">
						<i class="fa fa-clock-o"></i>{{careersList.job_type}}            
						</li>
						<li title="Department">
						<i class="fa fa-sitemap"></i>{{careersList.job_subtitle}}                      
						</li>
						<!--<li id="resumator-job-experience" title="Experience">
						<i class="fa fa-graduation-cap"></i>Mid Level               
						</li>-->
					</ul>
				</b-col>
				<b-col lg="5" md="12" sm="12">
					<div class="social-tools">
						<a class="btn btn-lg btn-gray" data-test="job-board-responsive-share" href="/careers"  role="button" data-track-share-click="Responsive">
							All Openings
						</a>
					</div> 
					</b-col>
				</b-row>
		</b-container>
	</div>
  
	
	 <b-container class="mt-0 jobs">
		 <b-row>
			<b-col lg="7" md="12" sm="12" class="jobs-description summary">
					<!-- {{careersList}}-->
<div class="description" >
	<span v-html="careersList.job_details"></span>
	
</div>
						<!-- <div class="description">
							<p><strong>Marketing &amp; Sales are key to our Platform reach and growth into the market.</strong></p>

							<p>The role of the eCommerce Designer is to provide visual responses to customer needs. They can be, among others, product cards, eStore Fronts, Shop in Shop, Landing pages and other graphic designs for eRetailers. These include new design creation and/or adaptation of existing brand template and updation of existing assets</p>
							<p><strong>What you&rsquo;ll be working on:</strong></p>

							<ul class="listStyleli">
							<li><strong>What you&rsquo;ll be working on:</strong> 
							<ul class="listStyleliChiels">
							<li>Conceptualizing creative ideas as per the requirement. </li>
							<li>Improving the design of the website. </li>
							<li>Establishing design guidelines, standards, and best practices. </li>
							<li>Maintaining the appearance of websites by enforcing content standards. </li>
							<li>Designing visual imagery for websites and ensuring that they are in line with branding for clients. </li>
							<li>Preparing design plans and presenting the website structures.</li>
							<li>Proficiency in graphic design software including Adobe Photoshop, Adobe Illustrator, and other visual design tools. Proficiency in front-end development web programming languages such as HTML and CSS, jQuery, and JavaScript </li>
							<li>Excellent visual design skills. Excellent communication skills. </li>
							<li>Responsible mainly for social media graphics, marketing collaterals, illustrations,</li>
							<li>Knowledge and understanding of typography, colour theory, image selection layouts, grids, templates, image use, and graphic design principles.</li>
							<li>Design creative for digital marketing like social media posts ad campaigns, blog posts images, and infographics mostly around programming material.</li>
							<li>Manage multiple projects and deliver work on time.</li>
							</ul>


							</li>

							</ul>


							<ul class="listStyleli">
							<li><strong>Comp &amp; Benefits - </strong>
							<ul class="listStyleliChiels">
							<li>For a 2 month contractto start</li>
							<li>Monthly remuneration between 15-20k per month + Incentives</li>
							<li>Get exposure to work with experienced founders/team/investors </li>
							<li>Get a direct insight into the eCommerce industry </li>
							<li>Opportunity to convert into a Full -Time role </li>
							</ul>
							</li>
							<li><strong>Who are we?  </strong>
							<ul class="listStyleliChiels">
							<li><strong>Alluraa.com</strong>&nbsp;is all about-&nbsp;<strong>how India Shops</strong>&nbsp;-there is always a trusted Sales Advisor who happily assists the buyers in making the right buying decisions. <strong>Alluraa.com</strong>&nbsp;is a unique platform which combines the best of assisted selling and carefully curated selection of high-quality products with the power of social interaction that connects customers across the country with well-known and upcoming brands.</li>
							</ul>
							</li>
							</ul>
						</div> -->
					
                   
				
				
				
				
				
				
				
				
				
				
				
			</b-col>
			<b-col lg="5" md="12" sm="12">
			<div class=" p-4 submit-form job-application-form">
				<h3 class="resumator-resume-text">
						Apply for this position    </h3>
			<div class="required-help-text">Required<i class="asterisk">*</i></div>
			
				<b-alert :show="form_alert.length > 0" variant="warning">
				  <p class="py-0 my-0" v-for="txt in form_alert" :key="txt">{{txt}}</p>
				</b-alert>
			   <!-- <b-form >@submit="onSubmit" @reset="onReset"-->
				  <form ref="form" @submit.stop.prevent="handleSubmitSalseadv">
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >First Name <i class="asterisk">*</i></label>
					 <b-form-group label-for="fullfnameSa-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.fname" invalid-feedback="First Name is required!" >
						<b-form-input id="fullfnameSa-input" :state="customerState.fname" v-model="customer.fname" @focusin="customerState.fname = null"></b-form-input>
					</b-form-group>
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Last Name <i class="asterisk">*</i></label>
					<b-form-group label-for="lnameSa-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.lname" invalid-feedback="Last Name is required!" >
						<b-form-input id="lnameSa-input" :state="customerState.lname" v-model="customer.lname"  @focusin="customerState.lname = null"></b-form-input>
					</b-form-group>
					
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Email Address <i class="asterisk">*</i></label>
					<b-form-group :state="customerState.email"  label-for="emailSa-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Email should be valid">
					<b-form-input id="emailSa-input" v-model="customer.email" :state="customerState.email"  @focusin="customerState.email = null"></b-form-input>
					</b-form-group>
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Phone <i class="asterisk">*</i></label>
					<b-form-group label-for="mobileSa-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.mobile" invalid-feedback="Mobile No is required!" >
					<b-form-input type="tel" id="mobileSa-input" :state="customerState.mobile" v-model="customer.mobile" @focusin="customerState.mobile = null"  maxlength="10" @keypress="onlyNumber"></b-form-input>
					</b-form-group>	
					
				  <b-row class="px-0 mb-3">
					<b-col>
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Resume <i class="asterisk">*</i></label>
						<div class="mb-2" v-if="attachType==0">
							<b-link class="resumator-resume-action" @click="attachType=1">Attach resume</b-link >
							or
							<b-link  class="resumator-resume-action" @click="attachType=2">Paste resume</b-link >
						</div>
						
						
							
							<b-row>
							<b-col v-if="attachType==1">
								Attach resume as .pdf, .doc, .docx, or .txt (limit 5MB) or <b-link  class="resumator-resume-action" @click="attachType=2">Paste resume</b-link >
								<!--<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Resume"></b-form-file> -->
								
								<b-form-group label-for="product_image_1-input" label-size="sm" label-class="mb-2" class="mb-1" :state="product_infState.product_image_1" invalid-feedback="Resume is required!" >
									<b-form-file type="file" ref="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Attach resume" id="product_image_1-input" :state="product_infState.product_image_1" @focusin="product_infState.product_image_1 = null" ></b-form-file>
								</b-form-group>
								
							</b-col>
							<b-col v-if="attachType==2">
								Paste your resume here or <b-link class="resumator-resume-action" @click="attachType=1">Attach resume files</b-link > 
								<b-form-group label-for="resumecopy-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.resumecopy" invalid-feedback="This is required!" >
									<b-form-textarea
								  id="resumecopy-input"
								  v-model="customer.resumecopy "
								  rows="1"
								  class="mb-3"
								:state="customerState.resumecopy" @focusin="customerState.resumecopy = null" ></b-form-textarea>
								</b-form-group>
							</b-col>
							
							</b-row>
							
							
							
							
							
					</b-col>
				  </b-row>
				  
				  <b-form-group label="Desired salary" label-for="ds-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.desired_salary" invalid-feedback="First Name is required!" >
						<b-form-input id="ds-input" :state="customerState.desired_salary" v-model="customer.desired_salary" @focusin="customerState.desired_salary = null"></b-form-input>
					</b-form-group> 
					
					
					<b-form-group label="Earliest start date?" label-for="ds-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.earliest_start_date" invalid-feedback="First Name is required!" >
						<b-form-input id="ds-input" :state="customerState.earliest_start_date" v-model="customer.earliest_start_date" @focusin="customerState.earliest_start_date = null"></b-form-input>
					</b-form-group>
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Where are you located? <i class="asterisk">*</i></label>
					 <b-form-group label-for="located-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.location" invalid-feedback="Location is required!" >
						<b-form-input id="located-input" :state="customerState.location" v-model="customer.location"  @focusin="customerState.location = null"></b-form-input>
					</b-form-group>
					
					
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >What makes you stand out for this position?</label>
					<b-form-textarea
					  id="textarea"
					  v-model="customer.makes_you_stand"
					  rows="1"
					  class="mb-3"
					></b-form-textarea>
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Tell us about your most memorable achievement and how you achieved it</label>
					<b-form-textarea
					  id="textarea"
					  v-model="customer.questionnaire"
					  rows="1"
					  class="mb-3"
					></b-form-textarea>
					
					
					<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >How did you hear about this position?  <i class="asterisk">*</i></label>
					
					
					<b-form-group label-for="howdidyouhear-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.howdidyouhear" invalid-feedback="This is required!" >
						<b-form-textarea
					  id="howdidyouhear-input"
					  v-model="customer.howdidyouhear "
					  rows="1"
					  class="mb-3"
					:state="customerState.howdidyouhear" @focusin="customerState.howdidyouhear = null" ></b-form-textarea>
					</b-form-group>
				
				 
				  <b-row>
					<b-col class="text-center">
					
					    <b-button type="submit" variant="danger" size="small" class="w-100" style="background-color: #e94f3d;">Submit Application</b-button>
					</b-col>
				  </b-row>
				<!-- </b-form> -->
			  </form>
			  </div>


				
  
			</b-col>
		</b-row>
	</b-container>
    

    
 
	
	
	
	
   
    <bottom-footer></bottom-footer>
    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import '../assets/careers.scss';

export default {
  name: "Faq",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
     /* document.body.className = 'promo';*/
  },
  mounted(){
		//
		
		  this.customer.job_id = this.$route.params.jobId;
		  this.init();
	},
  data() {
    return {
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
	  attachType:0,
	  submitUrl: this.$root.NEWAPIURL+'profileapi/updateResume',
	  recordUrl: this.$root.WEBAPI+'webapi/getCarearlist',
	  careersList:[],
	 customer:{
		job_id:'',
		fname:'',
		lname:'',
		mobile: '',
		email: '',
		location: '',
		desired_salary:'',
		earliest_start_date:'',
		makes_you_stand:'',
		questionnaire:'',
		howdidyouhear:'',
		resumecopy:'',
	  },
	  customerState:{
	  fullname:null,
	  fname:null,
	  lname:null,
	  mobile:null,
	  email:null,
	  location:null,
	  workarea:null,
	  other:null,
	  desired_salary:null,
		earliest_start_date:null,
		makes_you_stand:null,
		questionnaire:null,
		howdidyouhear:null,
		resumecopy:null,
	  },
	  product_inf: {},
	  product_infState: {product_image_1:null,
				 
				  },
	product_inforder: {
			order_1:1,
			order_2:2,
			order_3:3,
			order_4:4,
			order_5:5},
	  reqStr:'<i class="asterisk">*</i>',
      team:[
        {id:1, img:'', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that enable people from every stratum to earn an earnest livelihood.'},
        {id:2, img:'', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to enable the common man by leveraging technology and innovation.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 110, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { blank: true, blankColor: '#b7b7b7', width: 300, height: 300, fluidGrow: true, class: 'm1' },
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 50
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 150
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
		
      }
    }
  },
  methods: {
    init(){
		
		
		var self = this;
			
		self.axios.post(self.recordUrl, {
			accesskey: self.$session.get('access_key'),
			job_id:self.customer.job_id,
		})
		.then(function (response) {
			if(response.data.error == 0 || response.data.error == '0'){
				self.careersList = response.data.result.careersList[0];
				
				//self.filterChildCategory(0, 0, 0);
			}else if(response.data.error == 9){
				self.$root.forceLogout(response.data.message);
			}
			//setTimeout(self.initload, 1000*30);
		})
		.catch(function (error) {
			alert(error);
		});
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
	onlyNumber ($event) {
	   //console.log($event.keyCode); //keyCodes value
	   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
	   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
		  $event.preventDefault();
	   }
	},
	checkFormValiditySalseadv() {
		  var valid = true; 
		  if(this.customer.fname.length < 3){
		  valid = false;
		  this.customerState.fname = false;
		  }else{
		  this.customerState.fname= true;
		  }
		  if(this.customer.lname.length < 3){
		  valid = false;
		  this.customerState.lname = false;
		  }else{
		  this.customerState.lname= true;
		  }
		  
		  if(!this.validateemail(this.customer.email)){
			  valid = false;
			  this.customerState.email = false;
			}else{
			  this.customerState.email = true;
			}
		  
		  if(this.customer.mobile.length < 10){
		  valid = false;
		   this.customerState.mobile = false;
		  }else{
		  this.customerState.mobile = true;
		  }
		  
		  //console.log('product_image_1'+this.product_inf.product_image_1);
		  if(this.attachType==1){ 
			this.customer.resumecopy='';
			//const file = this.product_inf.product_image_1.files[0];
			/*const file = this.$refs.file.files[0];
			console.log('file.size:'+file.size) */
			/*if(typeof this.product_inf.product_image_1==='undefined'){
				valid = false;
				this.product_infState.product_image_1 = false;
			}else if(!file) {
				valid = false;
				this.product_infState.product_image_1 = false;
				
			  }else if(file.size > 5120) {
				valid = false;
				this.product_infState.product_image_1 = false;
			  }else{
				console.log('Valid');
			  
			  }*/ 
		  
			if(this.product_inf.product_image_1==''){
				valid = false;
				this.product_infState.product_image_1 = false;
			}else if(typeof this.product_inf.product_image_1==='undefined'){
				valid = false;
				this.product_infState.product_image_1 = false;
			}else{
				this.product_infState.product_image_1= true;
			} 
		 }
		  if(this.attachType==2){
			this.product_inf.product_image_1='';
			 if(this.customer.resumecopy.length<10){
			  valid = false;
			   this.customerState.resumecopy = false;
			  }else{
			  this.customerState.resumecopy = true;
			  }
		  }

		 if(this.customer.location==''){
			 valid = false;
			  this.customerState.location = false;      
		  }else{
		  this.customerState.location = true;
		  }

		  if(this.customer.howdidyouhear==''){
			 valid = false;
			  this.customerState.howdidyouhear = false;      
		  }else{
		  this.customerState.howdidyouhear = true;
		  }
		  return valid;
	},
	handleSubmitSalseadv(){
			if (!this.checkFormValiditySalseadv()) {
			return;
			}
			//alert('Test');
		   // return false;
			var self = this;
			console.log('vijay');
			//this.customer.job_id=1020;
			
			
			let formData = new FormData();
					formData.append('imagefile1', this.product_inf.product_image_1);
					
					formData.append('data', JSON.stringify(this.customer));
					formData.append('accesskey', this.$session.get('access_key'));

					self.axios.post(self.submitUrl, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
							self.customer={
								job_id:'',
								fname:'',
								lname:'',
								mobile: '',
								email: '',
								location: '',
								desired_salary:'',
								earliest_start_date:'',
								makes_you_stand:'',
								questionnaire:'',
								howdidyouhear:'',
								resumecopy:'',
							  };
							  self.customerState={
							  fullname:null,
							  fname:null,
							  lname:null,
							  mobile:null,
							  email:null,
							  location:null,
							  workarea:null,
							  other:null,
							  desired_salary:null,
								earliest_start_date:null,
								makes_you_stand:null,
								questionnaire:null,
								howdidyouhear:null,
								resumecopy:null,
							  };
							
							self.product_inf.product_image_1 = '';
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});


			/* self.axios.post(self.urlSellerReg, o).then(function (response) {
			if(response.data.error == 0 || response.data.error == '0'){
			self.$bvToast.toast(response.data.message, {
			  title: 'Register',
			  toaster: 'b-toaster-bottom-right',
			  autoHideDelay: 5000,
			  variant: 'success',
			  solid: true,
			  appendToast: true
			});
			//self.$root.flash_msg.msg = response.data.message;
			
			  if(self.customer.role == self.TYPE_SELLER){
				self.modal.msg = "Thanks for successfully registering your profile as a seller!";
			  }else{
				self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
			  }
			  
			  self.customer = {
				prefix: 'mr',
				role: self.TYPE_SELLER,
				fullname: '',
				mobile: '',
				email: '',
				workarea: '',
				location: '',
				other: ''
			  };
			  self.customerState = {
				fullname:null,
				mobile:null,
				email:null,
				workarea:null,
				location:null,
				other:null
			  };
			 // self.$bvModal.show('modal-status');
			 self.$router.push('/marketing/sales-advisor/thanks');
			  
			}else{
			self.error_msg = response.data.message;
			self.$bvToast.toast(response.data.message, {
			  title: 'Register',
			  toaster: 'b-toaster-bottom-right',
			  autoHideDelay: 5000,
			  variant: 'danger',
			  solid: true,
			  appendToast: true
			});
			}
			})
			.catch(function (error) {
			alert(error);
			}); */
		  },

  },
  metaInfo() {
		return{
			title: 'Careers | Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'careers alluraa' },
				{ name: 'description', content: 'careers alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
<style    lang="scss">
		.description {
			p{
				line-height:1.44; margin-top:16px; margin-bottom:3px;
				font-size:11pt; font-variant:normal; white-space:pre-wrap;font-family:Calibri,sans-serif;color:#373a3c;background-color:#ffffff;font-weight:400;font-style:normal;text-decoration:none;
				
			}
			
			ul{
				list-style-type:disc;
				li{
				color:#2d2d2d;
				font-size:11pt; font-variant:normal; 
				/*white-space:pre-wrap; */
				font-family:Calibri,sans-serif;
				background-color:#ffffff;
				font-weight:400;
				font-style:normal;
				text-decoration:none;
					ul{
						list-style-type: circle ;
						li{
						color:#2d2d2d;
						
						font-size:11pt; font-variant:normal;
						/* white-space:pre-wrap;*/
						font-family:Calibri,sans-serif;background-color:#ffffff;font-weight:400;font-style:normal;text-decoration:none;
						
						}
					
					
					}
				
				}
			}
			
			.listStyleli {
				list-style-type:disc;
				li{
				color:#2d2d2d;
				
				font-size:11pt; font-variant:normal; 
				/*white-space:pre-wrap; */
				font-family:Calibri,sans-serif;background-color:#ffffff;font-weight:400;font-style:normal;text-decoration:none;
				
				}
				
			}
		
		.listStyleliChiels {
			list-style-type: circle ;
			li{
			color:#2d2d2d;
			
			font-size:11pt; font-variant:normal;
			/* white-space:pre-wrap;*/
			font-family:Calibri,sans-serif;background-color:#ffffff;font-weight:400;font-style:normal;text-decoration:none;
			
			}
			
		}
		
		}
		
		

</style>
